import { useQuery } from '@tanstack/react-query';

import axiosInstance from 'src/utils/axios';

export const getRunStatus = async (runConfigId: string | undefined) => {
  try {
    const response = await axiosInstance.get(`/run_config/${runConfigId}/status`);
    return {
      status: response.data.status,
    };
  } catch (error) {
    return {
      error: error instanceof Error ? error.message : 'Failed to load summary',
    };
  }
};

export const useRunStatus = (runConfigId: string | undefined) => {
  const { data, isFetching } = useQuery({
    queryKey: ['status', runConfigId],
    queryFn: () => getRunStatus(runConfigId),
    enabled: !!runConfigId,
  });

  return {
    summaryStatus: data?.status || '',
    error: data?.error,
    isFetchingStatus: isFetching,
  };
};
